<template>
<div class="container">

<div class="row center empty" v-show="!list||list.length==0">
  <i class="fa fa-calendar"></i>
  <p>暂无预约</p>
</div>

<div class="myitem" v-for="v in list" :key="v.id">
  <div class="row">
  	<div class="col-3">体检时间</div>
  	<div class="col-7">
      {{v.yysj}} &nbsp;&nbsp;
       <mt-button size="small" @click="gettime(v)" v-if="v.state==0">修改</mt-button>
    </div>
  </div>	
  <div class="row">
  	<div class="col-3">体检人</div>
  	<div class="col-7">{{v.xm}}</div>
  </div>
  <div class="row">
  	<div class="col-3">体检套餐</div>
  	<div class="col-7">{{v.tcmc}}</div>
  </div>
  <div class="row">
  	<div class="col-3">体检分院</div>
  	<div class="col-7">{{v.hospital}}</div>
  </div>
  <div class="row">
    <div class="col-3">预约状态</div>
    <div class="col-7">
      {{v.state|status}}
      <mt-button v-show="v.state==0" type="danger" size="small" @click="cancel(v)">取消预约</mt-button>
    </div>
  </div>
    <div class="row" style="padding-top:.5rem;border-top:1px solid #eee;" @click="detail(v)">
    <div class="col-3 black">查看详情</div>
    <div class="col-6"></div>
    <div class="col-1 center"><i class="fa fa-angle-right"></i></div>
  </div>
</div>



<mt-popup class="popup" v-model="show" position="right">
<div class="row title center" @click="close">
  <i class="fa fa-angle-left"></i>
  预约详情
</div>  

<div class="row bwhite">
<div class="row gray" style="font-size:1.2rem;padding:.5rem;">
  体检人信息
</div>
<div class="row">
  <div class="col-3 gray">体检人</div>
  <div class="col-7">{{now.xm}}</div>
</div>
<div class="row">
  <div class="col-3 gray">性别</div>
  <div class="col-7">{{now.sex==1?"男":"女"}}</div>
</div>
<div class="row">
  <div class="col-3 gray">手机号码</div>
  <div class="col-7">{{now.dh1}}</div>
</div>
<div class="row">
  <div class="col-3 gray">身份证</div>
  <div class="col-7">{{now.sfzh}}</div>
</div>
<div class="row">
  <div class="col-3 gray">体检时间</div>
  <div class="col-7">{{now.yysj}}</div>
</div>
<div class="row">
  <div class="col-3 gray">体检分院</div>
  <div class="col-7">{{now.hospital}}</div>
</div>
</div>

<div class="row bwhite">
<div class="row gray" style="font-size:1.2rem;padding:.5rem;">
  体检套餐
</div>
<div class="row" style="padding:.3rem;">
  <div class="col-3">
    <img :src="pic" :alt="now.tcmc" class="img">
  </div>
  <div class="col-7">
    <p>{{now.tcmc}}</p>
    <p style="padding-top: .5rem;"><span class="price" v-show="price">{{price}}</span></p>
  </div>
</div>
</div>
</mt-popup>


<mt-popup v-model="showtime" :modal="false" class="time" popup-transition="popup-fade">
	<h3 class="center" @click="hidetime">请选择预约时间</h3>
	<div class="row cal" v-show="showtime&&time1">
		<cal :time="time1" @select="orderTime"></cal>
	</div>
	<div class="row cal" v-show="showtime&&time2">
		<cal :time="time2" @select="orderTime"></cal>
	</div>
	<div class="row center myclose">
		<mt-button type="danger" size="large" @click="hidetime">关 闭</mt-button>
	</div>
</mt-popup>

</div>	
</template>

<style scoped>
.container{background: rgb(251,251,251);}	
.myitem{border-radius: .3rem;background: white;padding:.5rem;
	float: left;width:96%;margin:2%;
	border:1px solid #eee;
}
.col-3{color:#adadad;}
.black{color:black;}
.row{margin:.25rem 0;}
.popup{width:100%;height:100%;overflow: auto;background:rgb(251,251,251);}
.center i{font-size: 1.5rem;color:#adadad;}
.empty i{font-size: 3rem;}
.empty p{padding:.5rem;}
.title{padding:.5rem;font-size: 1.2rem;color:rgb(0,144,255);border-bottom: .2rem solid #eee;background: white;}
.title i{float: left;margin-left:.5rem;color:rgb(0,144,255);}
.bwhite .row{padding:.3rem .5rem .3rem 1.5rem;}
.img{width:90%;margin:5%;}
.price{color:red;font-size: 1.2rem;}
.pd{padding:.5rem;}

.time{width:100vw;height:100%;overflow: auto;padding:.5rem;}
.pd{padding:.5rem 1rem 2rem;}
.cal{margin-bottom:.5rem;float: left;}
.myclose{width:100%;padding:.5rem 1rem;}
</style>

<script>
import cal from "../../lib/calendar.vue";

export default{
   data:function(){
       return {
         list:[],
         show:false,
         now:"",
         pic:picurl+"default.jpg",
         price:"",
         time1:"",
         time2:"",
         showtime:false,
         now:"",
       }
	},
  created:function(){
		this.init();
  },
  components:{cal},
  filters:{
    status:function(d){
      if(d==0){return "";}
      if(d==1){return "已经体检";}
      if(d==2){return "已经取消";}
      if(d==3){return "预约成功";}
    }
  },
  methods:{
    init:function(){
        this.$emit("setTitle","我的预约纪录");
        this.getlist();
    },
    gettime:function(v){
         if(v.state!=0){return;}
          var _this=this;
          this.now=v;
          var data={hos:v.hospital};
          fun.post(mydata.apiuser+"gettime",data,function(d){
          	console.log(d);
          	if(d.status==1){
          		if(d.info.total==0){_this.$toast("暂无可预约时间");return false;}
          		_this.time1=d.info.now;
          		_this.time2=d.info.next?d.info.next:"";
          		_this.showtime=true;
          	}else{
          		_this.$toast(d.info);
          	}
          })
	},
	orderTime:function(d){
        var data={
            xm:this.now.xm,
            sfzh:this.now.sfzh,
            xb:this.now.xb,
            hospital:this.now.hospital,
            lb:this.now.lb,
            wpid:this.now.wpid,
            yysj:this.now.yysj,
            new_yysj:d,
        }
        var _this=this;
        fun.post(mydata.api+"Member/edit_yysj",data,function(d){
            console.log(d);
            if(d.status==1){
                _this.now.yysj=data.new_yysj;
                    _this.showtime=false;
            }else{
            _this.$toast(d.info);
            }
        })
    },
    hidetime:function(){
        this.showtime=false;
    },
    cancel:function(v){
      var _this=this;
      fun.post(mydata.api+"Member/cancel_order",v,function(d){
        console.log(d)
        _this.$toast(d.info);
        if(d.status==1){v.state=2;}
      })
    },
    edit:function(d){
      //修改预约时间 edit_yysj
      console.log(d)
    },
    detail:function(v){
      this.pic=picurl+"default.jpg";
      this.show=true;
      this.now=v;
      var price=v.tcmc.match(/\[[\w\W]*\]/);
      if(price){
        this.price=price[0].replace("[","").replace("]","");
      }else{
        this.price=false;
      }
      var _this=this;
      var data={gucode:v.gucode};
      if(!data.gucode){return;}
      fun.post(mydata.apiuser+"goodpic",data,function(d){
        //console.log(d);
        if(d.status==1){
          _this.pic=picurl+d.info;
        }
      })
    },
    close:function(){
      this.show=false;
    },
    getlist:function(start){
        var data={
             start:start?start:0
        }
        var _this=this;
        fun.post(mydata.apiuser+"mybook",data,function(d){
            console.log(d);
            if(d.status==1){
                _this.list=d.info;
            }else{
                _this.$toast(d.info);
            }
        })
    },
    url:function(url){
      this.$router.push(url);
    }
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/mybook.vue